import { render, staticRenderFns } from "./UserEditCustomer.vue?vue&type=template&id=6d0d6faa"
import script from "./UserEditCustomer.vue?vue&type=script&lang=js"
export * from "./UserEditCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports